module.exports = __webpack_public_path__ + "static/img/oneplusdcb.1b055ce1.png";